import React from "react";

export default function ProdReadinessCard({ checks }) {
  return (
    <div className="rounded-2xl border p-4 shadow-sm">
      <h3 className="text-lg font-semibold mb-2">Production Readiness</h3>
      <ul className="space-y-1">
        {checks.map((c, i) => (
          <li key={i} className="flex items-center">
            <span
              className={`mr-2 h-2 w-2 rounded-full ${c.ok ? "bg-green-500" : "bg-yellow-500"}`}
            />
            <span className="text-sm">
              {c.label}
              {c.note ? ` — ${c.note}` : ""}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
